import styled from "styled-components";

export const AdvertisementWrapper = styled.div`
  padding: 60px 0px;
  position: relative;
  img {
    width: 100%;
    height: 500px;
    object-fit: cover;
  }
`;
